import { Component, OnInit } from '@angular/core';
import { Information } from '../../../../job-service/service-models/information';
import { QuestionComponent } from '../question-component';

@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.scss']
})
export class InformationComponent extends QuestionComponent<Information> implements OnInit {
  ngOnInit() {
    this.question = this.question || new Information();
  }
}
